import React from "react";
import ReactTooltip from 'react-tooltip'
import { Column, Row } from "./index";
import Image from "components/Image";
import { editIcon, editIcon_over, alertIcon_tri as alertIcon } from 'img/icons'
import style from "./layout.module.scss";

export default function InfoCell({ name, value = "-", um = "", alarmMessage, onEdit }) {
	return (
		<Row><Column style={{ padding: 10 }}>
			<div className={style.title}>{name}</div>
			<div className={style.underlined}>
				<span>{`${value ?? '-'} ${um ?? ''}`}</span>
				{onEdit && <Image
					src={editIcon}
					hover={editIcon_over}
					onClick={onEdit}
				/>}
				{alarmMessage && <div>
					<div data-tip={alarmMessage}>
						<img src={alertIcon} alt="alert" style={{width:"20px", height:"20px"}}/>
					</div>
					<ReactTooltip className={style.tooltip} effect='solid'/>
				</div>}
			</div>
		</Column></Row>
	)
}
